module.exports = __webpack_public_path__ + "static/media/LK_70_35.30990812.png";